import { selectAppData } from './common'
import { createSelector } from 'reselect'

const selectProduct = (state) => selectAppData(state).product

export const selectProductName = (state) => selectProduct(state).productName
const selectProductContent = (state) => selectProduct(state).productContent
const selectTransManufacturer = (state) => selectProduct(state).transManufacturer
const selectTransModel = (state) => selectProduct(state).transModel
export const selectSpecification = (state) => selectProduct(state).specification
const selectValueNames = (state) => selectProductContent(state).valueNames

export const selectAllValueNames = createSelector(
  [selectValueNames, selectTransManufacturer, selectTransModel],
  (valueNames, transManufacturer, transModel) => {
    return {
      ...valueNames,
      manufacturer: transManufacturer,
      model: transModel,
    }
  },
)

export const selectArrayTypes = createSelector([selectSpecification], combineToArrayTypes)

function combineToArrayTypes(specification) {
  return updateArrayTypes(specification)
}

export const updateArrayTypes = (specification, arrayTypes = {}, prefix = '') => {
  return (
    specification &&
    specification.fields
      .filter((field) => field.domain._type === 'object' || field.domain._type === 'array')
      .reduce((acc, field) => {
        switch (field.domain._type) {
          default:
            return acc

          case 'object': {
            return { ...acc, ...updateArrayTypes(field.domain.specification, acc, `${prefix}${field.name}-`) }
          }

          case 'array': {
            const { minLength, maxLength } = field.domain

            const updatedArrayTypes = !acc[field.name]
              ? {
                  ...acc,
                  [field.name]: {
                    length: minLength === 1 ? 2 : minLength,
                    minLength,
                    maxLength,
                    path: prefix,
                  },
                }
              : {
                  ...acc,
                  [field.name]: {
                    ...acc[field.name],
                    length: acc[field.name].length === null ? minLength : acc[field.name].length,
                    minLength,
                    maxLength,
                  },
                }

            return {
              ...acc,
              ...updateArrayTypes(field.domain.specification, updatedArrayTypes, `${prefix}${field.name}-`),
            }
          }
        }
      }, {})
  )
}
